module.exports = __webpack_public_path__ + "h5/img/yhk.4f0c9822.png";